export const postHolidaysInitState = {
	holidays: null,
	error: null,
	errorShow: false,
	loading: false,
};
